import { RedoModal } from "@redotech/redo-web/arbiter-components/modal/redo-modal";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";
import { OnboardingProps } from "../common";

export const OutboundViewsMovedModal = memo(function OutboundViewsMovedModal({
  handleComplete,
}: OnboardingProps) {
  return (
    <RedoModal
      hideCloseButton
      isOpen
      modalSize="sm"
      onModalCloseRequested={(reason) => {
        // Only allow dismissal via button click, not backdrop or escape
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
          return;
        }
      }}
      primaryButton={{ text: "Got it", onClick: handleComplete, size: "md" }}
      title="Views have moved"
    >
      <Flex align="center" dir="column" gap="xl" w="full">
        <Text fontSize="md" textAlign="left" textColor="secondary" w="full">
          All of your outbound Views and products are now contained within the
          Outbound navigation item.
        </Text>
        <img
          alt="Outbound views have moved"
          src="https://assets.getredo.com/cross-sell-popup/operations-nav-changes-v2.gif"
          style={{
            width: "400px",
            height: "276px",
            maxWidth: "100%",
            borderRadius: "8px",
            objectFit: "contain",
          }}
        />
      </Flex>
    </RedoModal>
  );
});
